<template>
  <el-card class="box-card">
    <div slot="header" class="box-head clearfix">
      <span class="card-head">Upcoming Scheduled Social Posts</span>
      <el-button style="float: right;" size="mini" @click="handleNewPost" plain>New Post</el-button>
    </div>
    <div class="card-content">
      <span v-if="posts.length !== 0">
        <scheduled-post
          v-for="post in orderedPosts"
          :key="post.id"
          :post="post"
          :channels="channels"
          @edit="onEditPost"
          @delete="onDeletePost"
        ></scheduled-post>
      </span>
      <p v-if="!posts.length" class="posts-placeholder">No Scheduled Posts</p>
    </div>
  </el-card>
</template>

<script>
import ScheduledPost from './ScheduledPost';

export default {
  name: 'ScheduledPostList',

  components: {
    ScheduledPost,
  },
  props: {
    posts: {
      type: Array,
      default: [],
    },
    channels: {
      type: Array,
      default: [],
    },
  },
  computed: {
    orderedPosts() {
      return this.posts
        .filter(p => !p.sent)
        .slice()
        .sort((a, b) => new Date(a.post_date) > new Date(b.post_date));
    },
  },

  methods: {
    handleNewPost() {
      this.$emit('newPost');
    },

    onDeletePost(id) {
      this.$emit('deletePost', id);
    },

    onEditPost(post) {
      this.$emit('editPost', post);
    },
  },
};
</script>

<style lang="scss" scoped>
$my-text-color: #676a6c;

.card-head {
  font-size: 1.3em;
}

.clearfix:after {
  clear: both;
}

.box-card {
  color: $my-text-color;
}

.box-head {
  height: 1.5em;
}

.card-content {
  margin: 0px;
  min-height: 150px;
}

.posts-placeholder {
  text-align: center;
  color: lighten($my-text-color, 25);
  font-size: 1.2em;
}

.paginate {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// ScheduledPostList.vue?54492e3c